import { type InferResponseType, unwrap } from "@nexxt/api-client";
import { filterQuery } from "@nexxt/app-kit";
import type { ListBlockedCustomersInput } from "@nexxt/contracts/sales";
import { infiniteQueryOptions } from "@tanstack/react-query";
import { api } from "../../api";

// Server state of the blocked customers (spec v0.2 §9, P8.10a): one read per page, each row with its open orders.
// Under the key of the sales orders, so a credit decision, an override and every write on an order read them again.

const customers = api.sales["blocked-customers"];

type ListPage = InferResponseType<typeof customers.$get, 200>;
export type BlockedCustomer = ListPage["items"][number];

/** The filters of the list input (`listBlockedCustomersInput`), without the paging the query adds. */
export type BlockedCustomerFilters = Pick<ListBlockedCustomersInput, "cause" | "q">;

const PAGE_SIZE = 50;

const keys = {
  all: ["sales-orders", "blocked-customers"] as const,
};

export const blockedCustomerQueries = {
  ...keys,

  /** By name. */
  list: (filters: BlockedCustomerFilters) =>
    infiniteQueryOptions({
      queryKey: [...keys.all, "list", filters],
      queryFn: ({ pageParam, signal }) =>
        unwrap(
          customers.$get(
            { query: { ...filterQuery(filters), page: String(pageParam), pageSize: String(PAGE_SIZE) } },
            { init: { signal } },
          ),
        ),
      initialPageParam: 1,
      getNextPageParam: (last) => (last.hasMore ? last.page + 1 : undefined),
    }),
};
